import { createFileRoute } from '@tanstack/react-router';

import { FacultyBrowse } from '@/module/Faculty/FacultyBrowse';

export const Route = createFileRoute('/_auth/administration/_administration/faculty/_faculty/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <FacultyBrowse />;
}
